import { render, staticRenderFns } from "./EditPreferencesModal.vue?vue&type=template&id=ecf892e8&scoped=true"
import script from "./EditPreferencesModal.vue?vue&type=script&lang=js"
export * from "./EditPreferencesModal.vue?vue&type=script&lang=js"
import style0 from "./EditPreferencesModal.vue?vue&type=style&index=0&id=ecf892e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf892e8",
  null
  
)

export default component.exports